import { render } from "./DefaultPage.vue?vue&type=template&id=0965dec6&scoped=true"
import script from "./DefaultPage.vue?vue&type=script&lang=js"
export * from "./DefaultPage.vue?vue&type=script&lang=js"

import "./DefaultPage.vue?vue&type=style&index=0&id=0965dec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0965dec6"]])

export default __exports__